/**
 * Citations config
 */
import { ICitationsTypes } from '../@types';

const citationsConfig: ICitationsTypes[] = [
	{
		type: 'References',
		style: 'decimal',
		displayKey: false,
		order: 10,
		renderer: 'CitationsList',
	},
	{
		type: 'Footnotes',
		style: 'unordered',
		displayKey: false,
		order: 20,
		renderer: 'CitationsUnordered',
	},
	{
		type: 'Abbreviations',
		style: 'unordered',
		sort: true,
		displayKey: true,
		order: 30,
		renderer: 'CitationsAbbreviations',
	},
];

export default citationsConfig;
